<template>
    <div class="trainingcourse">
         <div class="microclass-header">
           <div class="microclass-header-left">
                <img src="@/assets/images/trainingcourse/trainingcourse.png"/>
                <ul class="microclass-text" @click="btnColor">
                    <li v-for="(item,index) in tablist" :key="index" :class="item.active" >{{item.title}}</li>
                </ul>
           </div>
           <div class="microclass-header-right">
                <span class="microclass-right-text">更多</span>
                <img src="@/assets/images/home/arrows.png"/>
           </div>
       </div>
       <div class="line"></div>
       <!-- 视频区域 -->
       <div class="trainingvideo">
        <div class="trainingvideleft">
          <!-- <img src="@/assets/images/news-board/u44.svg" /> -->
          <!-- <video class="videopalys" src="https://jk.szrdpxcloud.com/jieshao.m4v"></video> -->
          <div class="videopalybox" @mouseover="isIn = true" @mouseout="isIn = false">
            <video
              ref="videoto"
              :controls="isIn"
              class="videopalys"
              style="height:321px;width:100%;object-fit: fill"
              src="https://jk.szrdpxcloud.com/jieshao.m4v"
              @click="suspend"
              controlslist="nodownload"
              disablepictureinpicture
            ></video>
            <i
              v-show="!isPlay"
              class="play-btn el-icon-video-play"
              style="z-index:1"
              @click="playVideock"
            ></i>
            <i
              v-show="isPlay && isIn"
              class="play-btn el-icon-video-pause"
              style="z-index:1"
              @click="pauseVideo"
            ></i>

            <img
              v-if="isviposter"
              src="@/assets/images/news-board/u44.svg"
              style="width:446px;height:321px; position: absolute;top: 0;left: 0;z-index:0"
            />
          </div>

          <div class="trainglefttext">
            <div class="traingleftname">刑侦</div>
            <p>法润人心：让“宣誓仪式”成为法治社会文化...</p>
          </div>
          <div class="traingimgnametxtlil">
            <div class="traintext"></div>
            <div class="trainicon" style="margin-right:14px">
              <img src="@/assets/images/traningschool/videoplimg.png" alt />
              <span>23</span>
            </div>
            <div class="trainicon">
              <img src="@/assets/images/traningschool/talkimg.png" alt />
              <span>16</span>
            </div>
          </div>
        </div>
        <div class="trainingvideright">
          <div class="trainingimgli" v-for="(item,index) in 6" :key="index">
            <img src="@/assets/images/news-board/u47.svg" />
            <i  class="play-btn el-icon-video-play" @click="newsVideo"></i>
            <div class="traingimgtext">
              <div class="traingimgname">刑侦</div>
              <p>本课程是物理分析专业的...</p>
            </div>
            <div class="traingimgnametxtlil">
              <div class="traintext"></div>
              <div class="trainicon" style="margin-right:14px">
                <img src="@/assets/images/traningschool/videoplimg.png" alt />
                <span>23</span>
              </div>
              <div class="trainicon">
                <img src="@/assets/images/traningschool/talkimg.png" alt />
                <span>16</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            opsterimg:
                'http://121.12.125.214:2364/images/%E9%A6%96%E9%A1%B5/%E8%A7%86%E9%A2%91_u139.png',
            nodownload: false,
            isPlay: false,
            isIn: false,
            autoplay: false,
            isviposter: true,
            tabActive: 0,

            tablist: [
                {
                title: '培训班课程',
                id: 1,
                 active:'active',
                },
                
            ],
        }
    },
    methods:{
      // 视频点击跳转到播放页面
      newsVideo(){
           console.log('跳转到视频新页面')
       },
        btnColor(ev){
           let title=ev.target.innerText
           if(title == this.tablist[0].title){
                this.tablist[0].active="active"
                this.tablist[1].active=""
           }else if(title == this.tablist[1].title){
                this.tablist[1].active="active"
                this.tablist[0].active=""
           }
       },
       tabHandleChange(index) {
      this.tabActive = index;
      this.$emit('tabChange', this.tabActive);
    },
    // 点击屏幕播放
    suspend() {
        let myVideo = this.$refs.videoto;
        // this.isPlay = !this.isPlay;
        if (this.isPlay) {
            myVideo.play();

            this.isPlay = false;
            this.isviposter = false; //隐藏封面
        } else {
            myVideo.pause();
            this.isPlay = true;
        }
        },
        // 点击播放
        playVideock() {
        //注意：这样获取的dom是一个数组，必须加上[0]索引才能正确的添加事件
        let myVideo = this.$refs.videoto;
        myVideo.play();
        this.isPlay = true;
        this.isviposter = false;
        },
        // 点击暂停
        pauseVideo() {
        let myVideo = this.$refs.videoto;
        myVideo.pause();
        this.isPlay = false;
        },
    }

}
</script>

<style lang="scss" scoped>
.trainingcourse{
    width: 1200px;
    background: #FFFFFF;
    opacity: 1;
    border-radius: 6px;
    margin: 20px 0;
    .microclass-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 56px;
        .microclass-header-left{
            display: flex;
            align-items: center;
            .microclass-text{
                display: flex;
                &>li{
                    width: 110px;
                    height: 22px;
                    font-size: 22px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    line-height: 22px;
                    color: #4876C4;
                    opacity: 1;
                    margin-left: 10px;
                }
                .active{
                    color: #4876C4;
                }
            }
        }
        .microclass-header-right{
            display: flex;
            align-items: center;
            .microclass-right-text{
                width: 32px;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #666666;
                opacity: 1;
            }
            &>img{
                opacity: 1;
                margin-left: 8px;
                margin-right: 24px;
            }
        }
    }
    .line{
        content: '';
        width: 1200px;
        height: 0px;
        border: 1px solid #CCCCCC;
        opacity: 1;
    }
    .trainingvideo {
      padding: 20px 20px;
      display: flex;
      .trainingvideleft {
        width: 446px;
        height: 321px;
        border-radius: 6px;
        .videopalybox {
          position: relative;
          width: 446px;
          height: 321px;
          .videopalys {
            border-radius: 6px;
          }
        }

        .trainglefttext {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #666;
          margin-top: 6px;
          .traingleftname {
            padding: 3px 5px;
            color: #fff;
            background-color: #4876c4;
            border-radius: 4px;
            font-size: 13px;
            margin-right: 5px;
          }
        }
      }
      .trainingvideright {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        .trainingimgli {
          width: 222px;
          margin: 0 0 15px 14px;
          position: relative;
          img {
            width: 222px;
            height: 136px;
            border-radius: 6px;
          }
          .traingimgtext {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #666;
            margin-top: 6px;
            .traingimgname {
              padding: 3px 5px;
              color: #fff;
              background-color: #4876c4;
              border-radius: 4px;
              font-size: 13px;
              margin-right: 8px;
            }
          }
          .traingimgnametxtlil {
            color: #999;
            font-size: 14px;
            display: flex;
            margin-top: 6px;
            .traintext {
              flex: 1;
            }
            .trainicon {
              display: flex;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
                margin-right: 2px;
              }
            }
          }
        }
      }
    }
    .traingimgnametxtlil {
        color: #999;
        font-size: 14px;
        display: flex;
        margin-top: 6px;
        .traintext {
            flex: 1;
        }
        .trainicon {
            display: flex;
            align-items: center;
            img {
            width: 16px;
            height: 16px;
            margin-right: 2px;
            }
        }
        }

        .gdbox {
        display: flex;
        align-items: center;
        color: #666;
        line-height: 50px;
        .gdimg {
            display: block;
            width: 16px;
            height: 16px;
            margin-left: 3px;
        }
    }
}
.play-btn{
    z-index: 1;
    font-size: 27px;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: -28px;
    &:hover {
        cursor: pointer;
    }
}
</style>